module.exports = __webpack_public_path__ + "img/Radio.77a8fe62.svg";